// extracted by mini-css-extract-plugin
export default {"image":"VX-z","loaded":"WX-z"};